import RadioButtonLabel from './RadioButtonLabel.component';

export default RadioButtonLabel;